import axios from '../../../core/services/axios';

export const getCustomMethodsList = (params) => axios.get('/api/custom-methods', { params });

export const deleteCustomMethodById = (id) => axios.delete(`/api/custom-methods/${id}`);
